import { render, staticRenderFns } from "./clientLevel.vue?vue&type=template&id=1839d069&"
import script from "./clientLevel.vue?vue&type=script&lang=js&"
export * from "./clientLevel.vue?vue&type=script&lang=js&"
import style0 from "./clientLevel.vue?vue&type=style&index=0&id=1839d069&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports